<script lang="ts">
import { defineComponent } from "vue";
import LoaderProgress from "@/components/bisom/loader/LoaderProgress.vue";
import BBrowserCompatibilityModal from "@/components/bisom/modal/BBrowserCompatibilityModal.vue";
// import FirebaseConfig from "@/components/FirebaseConfig.vue";
// Store
import { mapState } from "pinia";
import { useUserInfosStore } from "./stores/userInfosStore";

export default defineComponent({
  name: "App",

  components: {
    LoaderProgress,
    BBrowserCompatibilityModal,
    // FirebaseConfig,
  },

  computed: {
    ...mapState(useUserInfosStore, ["theme", "userOrganizationId"]),
  },
});
</script>

<template>
  <VApp :theme="theme">
    <VMain>
      <!-- <FirebaseConfig v-if="userOrganizationId" /> -->

      <router-view v-slot="{ Component }">
        <LoaderProgress />
        <transition name="viewTransition">
          <div :key="$route.path">
            <component :is="Component" />
            <BBrowserCompatibilityModal />
          </div>
        </transition>
      </router-view>
    </VMain>
  </VApp>
</template>

<style lang="css">
.viewTransition-enter-active {
  animation: fadeIn 1s linear;
}
@keyframes fadein {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 0.5;
  }
}

.viewTransition-leave-active {
  animation: fadeOut 0.2s linear;
}
@keyframes fadeOut {
  0% {
    opacity: 0.5;
    transform: translateX(0);
  }

  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}
</style>
